/**
 @ngdoc service
 @name mapAutomatedsearchTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapAutomatedsearchTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);
            tileFactory.addFieldToColumn1(tileFactory.field.newField('typeName'));
            tileFactory.addFieldToColumn2(tileFactory.field.newField('objectType'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('assigneeName'));
            tileFactory.addStatus(tileFactory.status.newStatus('automatedSearchStatus',
                    // Positives
                     [
                         'UNSEEN'
                     ]
                ));

            return tileFactory.tileData;
        };
        return {
            map : map
        };
    };

    mapAutomatedsearchTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapAutomatedsearchTileService', mapAutomatedsearchTileService);

}());